import {create} from "zustand";
import { UserListItemResponseDto } from '@/features/superAdmin/features/users/types/superAdmin-users-dto';

const DEFAULT_PAGE_SIZE = 10;

type UsersFilterType = {
    filter: {
        take: number;
        skip?: number;
        tenantId: string | null;
        orderBy?: Capitalize<keyof UserListItemResponseDto> | null;
        orderDirection: 'asc' | 'desc';
    },
    setFilter: ( filter: Partial<UsersFilterType['filter']> ) => void;
    resetFilter: () => void;
};

const defaultState: UsersFilterType['filter'] = {
    take: DEFAULT_PAGE_SIZE,
    skip: 0,
    tenantId: null,
    orderBy: null, 
    orderDirection: 'asc', 
};

export const useUsersFilter = create<UsersFilterType>((set) => ({
    filter: {...defaultState },
    setFilter: (newFilter) => {
        set((state) => ({
            filter: {
                ...state.filter,
                ...newFilter,
            },
        }));
    },
    resetFilter: () => {
        set({ 
            filter: {...defaultState },
        });
    },
}));